import React, { Component } from 'react';
import style from './index.module.css';

class Chapter7 extends Component<any> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { status, mileage, circle, isMultiCar, rule } = this.props.data;
    const { setInstructionModel } = this.props;
    // if (status === 0) return;

    return (
      <div
        className={style.pageBox}
        style={{
          height: document.documentElement.clientHeight - 0
        }}
      >
        {isMultiCar && rule && (
          <div
            className={style.instructionsIconBox}
            onClick={() => setInstructionModel(rule)}
          />
        )}
        {status === 1 && (
          <div className={style.itemBox}>
            {/* <div className={style.xpIconBox} /> */}
            <p className={style.ordinaryText}>
              <span className={style.blueNormalText}>2021年</span>
              <br />
              <span className={style.blueBigText}>你累计行驶</span>
              <span className={style.blueBigText}>{mileage}公里</span>
              {/* <br /> */}
            </p>
            <p className={style.grayNormalText}>
              人间万里，山海辽阔，明年陪你继续探索
            </p>
          </div>
        )}
        {status === 2 && (
          <div className={style.itemBox}>
            {/* <div className={style.xpIconBox} /> */}
            <p className={style.ordinaryText}>
              <span className={style.blueBigText}>{mileage}公里</span>
            </p>
            <p className={style.ordinaryText} style={{ marginTop: -40 }}>
              2021年你的行驶里程
              <br />
              相当于绕地球
              <span className={style.blueNormalText}>{circle || '--'}</span>，
              <br />
              <br />
              <br />
              <span className={style.grayNormalText}>
                人间万里，山海辽阔，明年陪你继续探索
              </span>
            </p>
          </div>
        )}
        <div
          className={status === 2 ? style.chapter702Icon : style.chapter7Icon}
        />
      </div>
    );
  }
}

export default Chapter7;
